import { ColumnDef } from "@tanstack/react-table";
import { Typography } from "@/core/components/ui/typography";
import { formatMoneyCents } from "@/core/utils/money";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";

export const AmountCol = (): ColumnDef<IInternalTransaction> => ({
  header: "Amount",
  accessorKey: "amount",
  cell: ({ row }) => {
    const { amount, type } = row.original;

    const isDeposit = type === "deposit";

    return (
      <Typography
        variant="bodyW1"
        textColor={isDeposit ? "interactive" : undefined}
      >
        {isDeposit && "+"}
        {formatMoneyCents(amount)}
      </Typography>
    );
  },
});
